package ui

import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.auto

object AppStyles : StyleSheet() {

    init {
        // 모든 요소에 border-box 적용 (패딩이 너비에 영향을 주지 않도록)
        "*" style {
            property("box-sizing", "border-box")
        }
    }

    // ==============
    // Page / Layout
    // ==============
    val container by style {
        padding(24.px)
        maxWidth(760.px)
        property("margin", "0 auto")
        property("width", "100%")
        fontFamily("Pretendard", "system-ui", "sans-serif")
    }

    val resultsPanel by style {
        marginTop(16.px)
        borderRadius(14.px)
        border(1.px, LineStyle.Solid, Color("#e5e7eb"))
        backgroundColor(Color.white)
        padding(18.px)
        property("box-shadow", "0 6px 18px rgba(0,0,0,.04)")
    }

    val resultCard by style {
        border(1.px, LineStyle.Solid, Color.lightgray)
        borderRadius(8.px)
        padding(16.px)
        marginBottom(16.px)
        backgroundColor(Color.white)
        property("box-shadow", "0px 4px 12px rgba(0, 0, 0, 0.05)")
    }

    // ====================
    // Header (logo + title)
    // ====================
    val headerCard by style {
        backgroundColor(Color.white)
        border(1.px, LineStyle.Solid, Color("#e5e7eb"))
        borderRadius(16.px)
        padding(22.px)
        property("box-shadow", "0 8px 24px rgba(0,0,0,.06)")
    }

    val headerRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(12.px)
        marginBottom(14.px)
        property("min-width", "0")
    }

    val headerTexts by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        property("min-width", "0")
    }

    val headerTitle by style {
        margin(0.px)
        fontSize(26.px)
        color(Color("#0f172a"))
        property("white-space", "nowrap")
        property("overflow", "hidden")
        property("text-overflow", "ellipsis")
    }

    val headerSubtitle by style {
        marginTop(4.px)
        color(Color("#64748b"))
        fontSize(14.px)
        property("white-space", "normal")
        property("overflow", "visible")
//        property("white-space", "nowrap")
//        property("overflow", "hidden")
//        property("text-overflow", "ellipsis")
    }

    val headerLogo by style {
        width(80.px)
        height(80.px)
        property("object-fit", "contain")
        property("flex-shrink", "0")
    }

    val disclaimerText by style {
        marginTop(10.px)
        marginBottom(0.px)
        color(Color("#64748b"))
        fontSize(15.px)
        lineHeight("1.5")
    }

    // ======================
// TriGroup (짧고 동일 높이 + 뱃지)
// ======================
    val triGroupGrid by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(3, minmax(0, 1fr))") // 한 줄 고정
        gap(10.px)
        marginTop(10.px)
        width(100.percent)
    }

    val triGroupItem by style {
        position(Position.Relative)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        property("justify-content", "center")
        padding(14.px, 10.px)
        borderRadius(12.px)
        property("border", "1px solid rgba(0,0,0,.06)")
        property("min-width", "0")
        textAlign("center")

        // ✅ 1) 높이 들쭉날쭉 방지: 같은 높이로 맞추기
        minHeight(120.px)
    }

    val triBadge by style {
        // ✅ 2) 신뢰도 배지: 카드 상단에 딱 붙이기
        position(Position.Absolute)
        top(8.px)
        left(8.px)
        padding(3.px, 7.px)
        borderRadius(999.px)
        fontSize(11.px)
        property("font-weight", "700")
        backgroundColor(Color.white)
        property("border", "1px solid rgba(0,0,0,.08)")
        property("white-space", "nowrap")
    }

    val triGroupTitle by style {
        fontSize(12.px)
        fontWeight("600")
        marginTop(18.px) // ✅ 배지 공간 확보
        property("white-space", "normal")
        property("overflow", "visible")
//        property("white-space", "nowrap")
//        property("overflow", "hidden")
//        property("text-overflow", "ellipsis")
        maxWidth(100.percent)
    }

    val triGroupIcon by style {
        // ✅ 2) 아이콘 더 작은 원
        width(34.px)
        height(34.px)
        borderRadius(999.px)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        fontSize(18.px)
        backgroundColor(Color.white)
        property("box-shadow", "0 1px 2px rgba(0,0,0,.06)")
        property("border", "1px solid rgba(0,0,0,.05)")
        marginTop(8.px)
        marginBottom(6.px)
        property("flex-shrink", "0")
    }

    val triGroupMainLine by style {
        fontSize(12.px)
        fontWeight("600")
        property("white-space", "normal")
        property("overflow", "visible")
//        property("white-space", "nowrap")
//        property("overflow", "hidden")
//        property("text-overflow", "ellipsis")
        maxWidth(100.percent)
    }

    val triGroupDetailLine by style {
        fontSize(12.px)
        color(Color("#4b5563"))
        property("white-space", "nowrap")
        property("overflow", "hidden")
        property("text-overflow", "ellipsis")
        maxWidth(100.percent)
        marginTop(2.px)
    }

    // =========================
    // Tabs area (left tabs + list)
    // =========================
    val tabsArea by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.FlexStart)
        marginTop(10.px)
        paddingTop(15.px)
        property("border-top", "1px solid #e5e7eb")
        property("border-top", "1px solid #e5e7eb")
        property("width", "100%")
        property("min-width", "0")
    }

    // VerticalVerdictTabs 컨테이너에 붙일 클래스 (세로 → 모바일 가로)
    val verdictTabs by style {
        width(120.px)
        paddingRight(10.px)
        marginRight(15.px)
        property("border-right", "1px solid #e5e7eb")
        property("flex-shrink", "0")
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(8.px)
    }

    // 탭 버튼에 붙일 클래스 (선택/비선택은 기존 로직대로 inline로 덮어써도 OK)
    val verdictTabButton by style {
        textAlign("left")
        padding(8.px, 10.px)
        borderRadius(10.px)
        border(1.px, LineStyle.Solid, Color("#e5e7eb"))
        backgroundColor(Color.white)
        cursor("pointer")
        fontSize(13.px)
        property("white-space", "nowrap")
    }

    // 오른쪽 리스트 영역
    val tabContent by style {
//        flexGrow(1)
//        property("flex-grow", "1")
//        minWidth(0.px)
//        display(DisplayStyle.Flex)
//        flexDirection(FlexDirection.Column)
        property("flex-grow", "1")
        property("min-width", "0")
    }

    // ======================
// Mobile tweaks
// ======================
    init {
        media("(max-width: 600px)") {
            // 전체 padding 줄이기
            ".$container" style { padding(5.px) }
            ".$resultsPanel" style { padding(10.px) }
            ".$resultCard" style { padding(10.px) }

            // ✅ 3) 헤더 타이틀/서브 모바일에서 작게 + 줄바꿈 덜
            ".$headerRow" style { gap(10.px) }
            ".$headerTitle" style { fontSize(16.px) }
            ".$headerSubtitle" style { fontSize(12.px) }

            ".$headerLogo" style {
                width(40.px)
                height(40.px)
            }

            ".$disclaimerText" style {
                fontSize(12.px)
                lineHeight("1.4")
                marginTop(8.px)

            }

            // 검색창 글씨도 살짝 줄이고 싶으면 (선택)
            // input 자체는 inline style로 주고 있으니, 나중에 class로 빼면 더 깔끔

            // ✅ TriGroup: 모바일에서 더 컴팩트
            ".$triGroupGrid" style { gap(6.px) }

            ".$triGroupItem" style {
                padding(10.px, 6.px)
                borderRadius(10.px)
                minHeight(108.px) // 모바일에서 조금 더 낮게
            }

            ".$triBadge" style {
                top(6.px); left(6.px)
                fontSize(10.px)
                padding(2.px, 6.px)
            }

            ".$triGroupTitle" style {
                fontSize(11.px)
                marginTop(16.px)
            }

            ".$triGroupIcon" style {
                width(30.px)
                height(30.px)
                fontSize(16.px)
                marginTop(6.px)
                marginBottom(4.px)
            }

            ".$triGroupMainLine" style { fontSize(11.px) }

            // ✅ 모바일에서 상세 수치 줄은 숨김 (더 짧게)
            ".$triGroupDetailLine" style { display(DisplayStyle.None) }
        }


        // 세로탭 → 모바일 가로탭(스크롤)
        // Styles.kt의 media("(max-width: 640px)") 블록 수정

        media("(max-width: 640px)") {
            ".$tabsArea" style {
                flexDirection(FlexDirection.Column)
                width(100.percent)
                property("min-width", "0")
                property("overflow", "hidden")
            }

            ".$verdictTabs" style {
                width(100.percent)
                paddingRight(0.px)
                marginRight(0.px)
                property("border-right", "none")
                property("border-bottom", "1px solid #e5e7eb")
                paddingBottom(8.px)
                marginBottom(12.px)

                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Row)
                property("overflow-x", "auto") // 탭 버튼들은 가로 스크롤 허용
                property("white-space", "nowrap")
                gap(8.px)
            }

            ".$verdictTabButton" style{
                padding(8.px, 7.px)
                borderRadius(10.px)
                border(1.px, LineStyle.Solid, Color("#e5e7eb"))
                backgroundColor(Color.white)
                cursor("pointer")
                fontSize(13.px)
                property("white-space", "nowrap")
            }


            // [중요] 탭 아래 리스트 영역도 너비 제한
            ".$tabContent" style {
                width(100.percent)
                property("min-width", "0")
            }
        }
    }
}
